import { signalStore, withState } from '@ngrx/signals';
import { withFilter } from '../../shared/stores/filter.feature.store';

type TestState = {
  loading: boolean;
};

const initialState: TestState = {
  loading: false,
};

export const testStore = signalStore({ providedIn: 'root' }, withState<TestState>(initialState), withFilter());
